import Component from "./PuppyBowlSnapshot";
export default Component;
